import "./plugins/routerHooks";
import Vue from "vue";
import App from "./App.vue";
import router from "./modules/router";
import store from "./domain/store";
import vuetify from "./plugins/vuetify";
import "./plugins/jquery";
import "./modules/filters";
// import './modules/registerServiceWorker';
import { setUserID } from "./modules/gtag";

import * as util from "./util";
import * as backend from "./domain/backend";

// Default styles
import "@mdi/font/css/materialdesignicons.css";
import "@/css/common.scss";
import { tablePaginationOptions } from "./uiUtil/vuetify";

Vue.config.productionTip = false;

// Initialize Firebase
backend.initialize();

// Session detect
backend.onAuthStateChanged((fbPartialUser) => {
  setUserID(fbPartialUser ? fbPartialUser.uid : "");
  util.promiseEnd(store.dispatch("loadUser", fbPartialUser));
});

const app = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  computed: {
    isMobile(): boolean {
      return this.$vuetify.breakpoint.smAndDown;
    },
    vuePaginationOptions(): (number | { text: string; value: number })[] {
      return tablePaginationOptions(this.isMobile);
    }
  }
});
app.$mount("#app");
